import React from 'react';
interface VerificationStepProps {
  title: string;
  description: string;
  icon: ReactNode;
  children: ReactNode;
}
const VerificationStep: React.FC<VerificationStepProps> = ({
  title,
  description,
  icon,
  children
}) => {
  return <div data-id="element-243">
      <div className="flex items-center mb-4" data-id="element-244">
        <div className="mr-4" data-id="element-245">{icon}</div>
        <div data-id="element-246">
          <h2 className="text-xl font-bold text-gray-800" data-id="element-247">{title}</h2>
          <p className="text-gray-600" data-id="element-248">{description}</p>
        </div>
      </div>
      {children}
    </div>;
};
export default VerificationStep;